import { createApp } from 'vue'
import App from './App.vue'
import './assets/style.css'
import ClickOutside from './v-click-outside';
import router from './router';
import VueGoogleMaps from '@fawmi/vue-google-maps';
import { getTheme, setTheme } from './theme';
import { createPinia } from 'pinia';
import { createHead } from '@vueuse/head';

const savedTheme = getTheme();
const pinia = createPinia();
const head = createHead();

setTheme(savedTheme);
const app = createApp(App);
app.use(pinia);
app.use(router);
app.use(head);
app.use(VueGoogleMaps, {
    load: {
        key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
        libraries: 'places', 
    },
  });


  
app.directive('click-outside', ClickOutside);
app.mount('#app')

